import bindAllMethods from '../../utils/bindAllMethods';
import IMonitoringService from './IMonitoringService';
import { SpanPropertiesType, DatadogInputType, SpanType } from './types';
import { InternalService } from '../../core/services';
import { internalLogger } from '../../interface/v1/clientOsLogger';

export default class DatadogService
  extends InternalService
  implements IMonitoringService
{
  private _enabled: boolean;
  constructor(monitoringProps: DatadogInputType) {
    super();
    this._enabled = monitoringProps.enabled;

    bindAllMethods(this);
    this._markAsReady();
  }

  private _getInstance(): any {
    const instance = (window as any)?.DD_RUM;
    if (!instance) {
      internalLogger?.debug?.d6({
        className: 'DatadogService',
        methodName: '_getInstance',
        libraryName: 'DD_RUM',
        message: 'DD_RUM is not available on window'
      });
    }
    return instance;
  }

  public getSessionId(): string {
    const sessionId = this._getInstance()?.getInternalContext()?.session_id;
    if (!sessionId) {
      internalLogger?.debug?.d1({
        className: 'DatadogService',
        methodName: 'getSessionId',
        variableName: 'session_id',
        currentValue: sessionId
      });
    }
    return sessionId;
  }

  public startSpan(
    name: string,
    attributes: SpanPropertiesType['attributes']
  ): SpanType {
    return {
      end: () => {
        const instance = this._getInstance();
        if (!instance) {
          internalLogger?.debug?.d6({
            className: 'DatadogService',
            methodName: 'startSpan > end',
            libraryName: 'DD_RUM',
            message: `DD_RUM is not available, span "${name}" cannot be ended`
          });
          return;
        }
        instance.addAction(name, {
          ...attributes
        });
      }
    };
  }

  public isEnabled(): boolean {
    return this._enabled;
  }
}
